import React from 'react'
import { useTheme, makeStyles } from '@material-ui/core/styles'

import Sidenav from '../../Sidenav/Sidenav'
import Brand from '../../Brand/Brand'
import SectionRail from './SectionRail'
import MobileSectionSheet from './MobileSectionSheet'
import { convertHexToRGB } from 'utils'
import useSettings from 'app/hooks/useSettings'
import useIsMobile from 'app/hooks/useIsMobile'
import useFeatureFlag from 'app/ducks/featureFlags/hooks'
import { SECTION_NAV_FLAG } from 'app/navigation/sectionNavFlag'

const useStyles = makeStyles(({ palette, ...theme }) => ({
  sidenav: ({ width, primaryRGB, primaryRGBContrast }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: width,
    boxShadow: theme.shadows[8],
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top',
    backgroundSize: 'cover',
    zIndex: 111,
    overflow: 'hidden',
    color: primaryRGBContrast,
    transition: 'all 250ms ease-in-out',
    backgroundImage: `linear-gradient(to bottom, rgba(${primaryRGB}, 0.96), rgba(${primaryRGB}, 0.96)), url(${theme.loginBg})`,
    '&:hover': {
      width: 'var(--sidenav-width)',
      '& .sidenavHoverShow': {
        display: 'block',
      },
      '& .compactNavItem': {
        width: '100%',
        maxWidth: '100%',
        '& .nav-bullet': {
          display: 'block',
        },
        '& .nav-bullet-text': {
          display: 'none',
        },
      },
    },
  }),
  hideOnCompact: {
    display: 'none',
  },
  userInfo: {},
}))

// Behind the `new_navigation` feature flag (see docs/FEATURE_FLAGS.md):
// off renders the original ~20-item Brand+Sidenav list exactly as
// before (desktop and mobile alike). On, desktop gets the 80px
// `SectionRail`; mobile gets `MobileSectionSheet` instead — a
// full-screen sheet, not the same narrow rail squeezed onto a phone.
const Layout1Sidenav = () => {
  const sectionNavEnabled = useFeatureFlag(SECTION_NAV_FLAG)
  const isMobile = useIsMobile()
  const theme = useTheme()

  const { settings } = useSettings()

  const leftSidebar = settings.layoutSettings.leftSidebar
  const { mode } = leftSidebar

  const getSidenavWidth = () => {
    switch (mode) {
      case 'compact':
        return 'var(--sidenav-compact-width)'
      default:
        return 'var(--sidenav-width)'
    }
  }

  const classes = useStyles({
    ...leftSidebar,
    width: getSidenavWidth(),
    primaryRGB: convertHexToRGB(theme.palette.primaryDark.main),
    primaryRGBContrast: theme.palette.primaryDark.contrastText,
  })

  if (sectionNavEnabled)
    return isMobile ? <MobileSectionSheet /> : <SectionRail />

  return (
    <div className={classes.sidenav}>
      <div className="flex-column relative h-full">
        <Brand />
        <Sidenav />
      </div>
    </div>
  )
}

export default React.memo(Layout1Sidenav)
